import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    employeeLeaves: [],
    leave: {},
    totalItems:0
};

const getters = {
    index: state => employeeLeaveId => state.employeeLeaves.findIndex(i => i.employeeLeaveId === employeeLeaveId)
};

const mutations = {
    setEmployeeLeaves: (state, r) => (state.employeeLeaves = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    add: (state, r) => state.employeeLeaves.unshift(r),
    delete: (state, index) => state.employeeLeaves.splice(index, 1),
    setLeave: (state, r) => (state.leave = r),
    edit: (state, { index, r }) => state.employeeLeaves.splice(index, 1, r),
    approve: (state, index) => state.employeeLeaves[index].status = status.approved,
    reject: (state, index) => state.employeeLeaves[index].status = status.rejected,
    cancel: (state, index) => state.employeeLeaves[index].status = 7,
    setVacationsBalance: (state, vacationsBalance) => (state.vacationsBalance = vacationsBalance),
};

const actions = {
    async getAll({ commit }, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");

            startLoading()
            const response = await dataService.employeeLeaves.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            commit("setEmployeeLeaves", response.data.employeeLeaves);
            commit("setTotalItems", response.data.totalItems);

        } catch (error) {
            console.log(error)
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {

            let formdata = new FormData()
            formdata.append("employeeVacationBalanceId", payload.employeeVacationBalanceId)
            formdata.append("employeeId", payload.employeeId)
            formdata.append("vacationTypeId", payload.vacationTypeId)
            formdata.append("startDate", payload.startDate)
            formdata.append("endDate", payload.endDate)
            formdata.append("duration", payload.duration)
            formdata.append("description", payload.description)
            formdata.append("attachmentName", payload.attachmentName)
            formdata.append("file", payload.file)
            formdata.append("hasOffical", payload.hasOffical)
            formdata.append("officialHoliday", payload.officialHoliday)



            startLoading()
            const response = await dataService.employeeLeaves.add(formdata);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);
            commit("add", response.data.leave);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeLeaves.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async approve({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeLeaves.approve(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("approve", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async reject({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.employeeLeaves.reject(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("reject", index);
        } catch (error) {

            stopLoading()
            catchHandler(error);
        }
    },
  
    async getDetails({ commit }, id) {
        try {
           
            startLoading()
            const response = await dataService.employeeLeaves.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            commit("setLeave", response.data.leave);
            
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.employeeLeaves.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.leave);
         
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            let formdata = new FormData()
            formdata.append("employeeId", payload.employeeId)
            formdata.append("startDate", payload.startDate)
            formdata.append("endDate", payload.endDate)
            formdata.append("duration", payload.duration)
            formdata.append("description", payload.description)
            formdata.append("attachmentName", payload.attachmentName)
            formdata.append("file", payload.file)
            formdata.append("hasOffical", payload.hasOffical)
            formdata.append("officialHoliday", payload.officialHoliday)


            startLoading()
            const response = await dataService.employeeLeaves.edit(id, formdata);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
           
            const index = getters.index(id);
            commit("edit", { index, r: response.data.leave });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
   async return({ commit, getters }, { id, payload }) {
        try {
            console.log(payload);
            let formdata = new FormData()
            formdata.append("ReturnDate", payload.returnDate)
            formdata.append("remark", payload.remark)
            formdata.append("file", payload.file)
            formdata.append("hasOffical", payload.hasOffical)
            formdata.append("officialHoliday", payload.officialHoliday)
            console.log(formdata);
         

            startLoading()
            const response = await dataService.employeeLeaves.returnLeaves(id, formdata);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }
           
            const index = getters.index(id);
            commit("edit", { index, r: response.data.leave });

        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },

    async getVacationsBalance(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            startLoading();
            const response = await dataService.employeeLeaves.getVacationsBalance(paramsString);
            stopLoading();

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            console.log(response);
            return Promise.resolve(response.data);
        } catch (error) {
            stopLoading();
            const err = error.response.data;
            showAlert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
      //------------------------------------------------------//
      async getForPrint(_, id) {
        console.log(id);

        try {
            startLoading()
            const response = await dataService.employeeLeaves.getForPrint(id);
            stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);
         

        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
